import React, { useState } from "react";
import { Button } from "react-bootstrap";
import TeachrCard from "./TeachrCard";
import ClientDialogLayout from "./ClientDialogLayout";
import moment from "moment";
import Functions from "../../../Helpers/Functions";

export interface CourseProposal {
  id: number;
  teacherName: string;
  startDatetime: string;
  endDatetime: string;
  description?: string;
  isRemote: boolean;
  isCourseInTheHour: boolean;
  duration?: number;
  creationDatetime?: Date;
  priceRate: number;
  finalTotal: number;
  averageNote: any;
  teacherId: number | undefined;
  isAccepted: boolean;
  isRefused: boolean;
}

interface ClientCourseProposalsProps {
  proposals: CourseProposal[];
  punctualId?: number;
  toggleRow?: (id: number) => void;
  activeRow?: number | null;
  load?: boolean;
  setLoad?: React.Dispatch<React.SetStateAction<boolean>>;
  isHome?: boolean;
  clientId?: number;
  refetchCourses?: () => void; 
  duration?:number; 
}

const ClientCourseProposals: React.FC<ClientCourseProposalsProps> = ({
  proposals,
  refetchCourses,
  duration,
}) => {
  const [openProposal, setOpenProposal] = useState<CourseProposal | null>(null);
  const [localProposals, setLocalProposals] =
    useState<CourseProposal[]>(proposals);

  const handleShowDetail = (proposal: CourseProposal) =>
    setOpenProposal(proposal);

  const handleCloseShowDetail = () => setOpenProposal(null);

  const handleRefuseProposal = (proposalId: number) => {
    setLocalProposals((prev) =>
      prev.map((p) =>
        p.id === proposalId ? { ...p, isRefused: true, isAccepted: false } : p
      )
    );

    if (openProposal?.id === proposalId) setOpenProposal(null);
  };

  const handleAcceptProposal = (proposalId: number) => {
    setLocalProposals((prev) =>
      prev.map((p) =>
        p.id === proposalId ? { ...p, isAccepted: true, isRefused: false } : p
      )
    );

    // Close dialog
    if (openProposal?.id === proposalId) setOpenProposal(null);

    // refetchCourses from the index i am passing it here 
    refetchCourses?.();
  };


  if (localProposals.length === 0)
    return <p>Aucune proposition de cours pour le moment.</p>;

  const refused = (
    <small className="inline-block text-red-800 px-2 bg-red-100 border border-red-200 rounded-full">
      Refusé
    </small>
  );
  const ongoing = (
    <small className="inline-block text-blue-800 px-2 bg-blue-100 border border-blue-200 rounded-full">
      En Cours
    </small>
  );

  const Accepted = (
    <small className="inline-block text-blue-800 px-2 bg-blue-100 border border-blue-200 rounded-full">
      Accepté 
    </small>
  );

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full border border-gray-300">
        <thead className="bg-gray-100">
          <tr className="bg-[#4077B6] text-white uppercase">
            <th className="px-4 py-2 text-left">Professeur</th>
            <th className="px-4 py-2 text-left">Nombre d’heures</th>
            <th className="px-4 py-2 text-left">Statut</th>
            <th className="px-4 py-2 text-right">Prix / heure</th>
            <th className="px-4 py-2 text-right">Prix total</th>
            <th className="px-4 py-2 text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          {localProposals.map((proposal) => (
            <tr key={proposal.id} className="hover:bg-gray-50 border">
              <td className="px-4 py-2 flex gap-2 items-center">
                <div className="bg-profilePic h-8 w-8 bg-cover" />
                <div>{proposal.teacherName}</div>
              </td>
              <td className="px-4 py-2">
                {Functions.renderTeachrHours(
                  moment
                    .duration(
                      moment(proposal.endDatetime).diff(
                        moment(proposal.startDatetime)
                      )
                    )
                    .asHours()
                )}
              </td>
              <td className="px-4 py-2">
                {proposal.isRefused
                  ? refused
                  : proposal.isAccepted
                  ? Accepted
                  : ongoing}
              </td>
              <td className="px-4 py-2 text-right">{proposal.priceRate} €</td>
              <td className="px-4 py-2 text-right">
                {(
                  proposal.priceRate * (duration ?? proposal.duration ?? 1)
                ).toFixed(2)}{" "}
                €
              </td>
              <td className="px-4 py-2 text-center">
                <Button
                  onClick={() => handleShowDetail(proposal)}
                  className="px-2 py-1 text-sm rounded-md bg-[#4077B6] text-white hover:bg-[#305f8e]"
                >
                  En savoir plus
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {openProposal && (
        <ClientDialogLayout
          title="Détails du cours"
          text=""
          open
          handleClose={handleCloseShowDetail}
          handleCloseIcon={handleCloseShowDetail}
        >
          <TeachrCard
            openProposal={{
              ...openProposal,
              teachrId: openProposal.teacherId!,
              isAccepted: openProposal.isAccepted ?? false,
              isRefused: openProposal.isRefused ?? false,
            }}
            onRefuse={handleRefuseProposal}
            onAccept={handleAcceptProposal}
            duration={duration}
          />
        </ClientDialogLayout>
      )}
    </div>
  );
};

export default ClientCourseProposals;
